/* eslint-disable @typescript-eslint/no-var-requires */
import defaultSEO from './default.json';
import { seoT } from './types';
import usSEO from './US.json';

let seo: Partial<seoT> = defaultSEO;

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-us') seo = usSEO;

export default seo as seoT;
